// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { mergeClasses } from '@fluentui/react-components';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { CourseContext, getCourse, getIsLoadingCourses, useConfig } from '../../data';
import { useAppStyles } from '../../styles';
import { LoadingCard } from '../common';
import CourseCard from './course-card';

/** List of hero courses. */
export const HeroCourses = () => {
    const appStyles = useAppStyles();
    const navigate = useNavigate();
    const [store] = useContext(CourseContext);
    const isLoading = getIsLoadingCourses(store);
    const { heroCourses } = useConfig();
    const courses = heroCourses?.split(',').map((o) => getCourse(store, o)) ?? [];
    return (
        <div className={mergeClasses(appStyles.sectionContent, appStyles.cardsContainer)}>
            {isLoading && <LoadingCard showImage />}
            {!isLoading &&
                courses.map((o) =>
                    !o ? undefined : (
                        <CourseCard
                            {...o}
                            tags={undefined}
                            key={o!.id}
                            className={appStyles.cardThreeColumns}
                            onClick={() => navigate(`/courses/${o!.id}`)}
                        />
                    )
                )}
        </div>
    );
};

export default HeroCourses;
